import Vue from "vue";
import VueRouter from "vue-router";
import HomePage from "@/views/HomePage";
import LoginPage from "@/views/LoginPage";
import TeamPage from "@/views/TeamPage";
import PoiPage from "@/views/PoiPage.vue";
import GeolocPage from "@/views/GeolocPage.vue";
import KmPage from "@/views/KmPage.vue";
import HmPage from "@/views/HmPage.vue";
import DispoPage from "@/views/DispoPage";
import MonitoringPage from "@/views/MonitoringPage";
import InfoBatteryPage from "@/views/InfoBatteryPage";
import PasswordPage from "@/views/Password.vue";
import PasswordResetPage from "@/views/PasswordResetPage.vue";
import NoticePage from "@/views/NoticePage.vue";
import AlertPage from "@/views/AlertPage.vue";
import HistoryPage from "@/views/HistoryPage.vue";
import MagicPage from "@/views/MagicPage.vue";
import InfoLocoPage from "@/views/InfoLocoPage.vue";
import NotFoundPage from "@/views/404Page";
import store from "./store/index";
import PortalAlertTable from "@/components/PortalAlertTable.vue";
import WheelsetPage from "@/views/WheelsetPage.vue";
import MaintenancePage from "@/views/MaintenancePage";
import JobPlanPage from "@/views/JobPlanPage";
import EdlPage from "@/views/EdlPage";
import KrefeldPlanPage from "@/views/KrefeldPlanPage";
import KrefeldDocumentsPage from "@/views/KrefeldDocumentsPage";
import GeofencingPage from "@/views/GeofencingPage.vue";
import QuotePage from "@/views/QuotePage.vue";
import AlertSrTable from "@/components/AlertSrTable.vue";
//import DisponibilityPage from "./views/DisponibilityPage.vue";
import DisponibilityContractuellePage from "./views/DisponibilityContractuelle.vue"
import AlertQuotation from "@/components/AlertQuotation.vue";
import InternLocoPage from "@/views/InternLocoPage.vue";
import AdminPage from "@/views/AdminPage.vue";
import AdminUserPage from "@/views/AdminUserPage.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "LoginPage",
    component: LoginPage,
    meta: {
      analyticsIgnore: true,
    },
  },
  {
    path: "/config",
    name: "AdminPage",
    component: AdminPage,
    meta: {
      requiredAuth: true,
      analyticsIgnore: false,
    },
  },
  {
    path: "/config/users",
    name: "AdminUsersPage",
    component: AdminUserPage,
    meta: {
      requiredAuth: true,
      analyticsIgnore: false,
    },
  },
  {
    path: "/",
    name: "HomePage",
    component: HomePage,
    meta: {
      requiredAuth: true,
      breadcrumb: [{ name: "message.aside.home" }],
      module: "myfleet",
    },
  },
  {
    path: "/team",
    name: "TeamPage",
    component: TeamPage,
    meta: {
      requiredAuth: true,
      module: "myfleet",
      breadcrumb: [
        { name: "message.aside.home", link: "/" },
        { name: "message.aside.account" },
        { name: "message.aside.profil" },
      ],
    },
  },

  {
    path: "/notice",
    name: "NoticePage",
    component: NoticePage,
    meta: {
      requiredAuth: true,
      module: "myfleet",
      breadcrumb: [
        { name: "message.aside.home", link: "/" },
        { name: "message.aside.account" },
        { name: "message.aside.notice" },
      ],
    },
  },
  {
    path: "/jobplan",
    name: "JobPlanPage",
    component: JobPlanPage,
    meta: {
      requiredAuth: true,
      module: "mymint",
      breadcrumb: [
        { name: "message.aside.home", link: "/" },
        { name: "message.aside.jobplan" },
      ],
    },
  },
  {
    path: "/history",
    name: "HistoryPage",
    component: HistoryPage,
    meta: {
      requiredAuth: true,
      module: "mymint",
      breadcrumb: [
        { name: "message.aside.home", link: "/" },
        { name: "message.aside.history" },
      ],
    },
  },
  {
    path: "/krefeldplan",
    name: "KrefeldPlan",
    component: KrefeldPlanPage,
    meta: {
      requiredAuth: false,
      module: "mymint",
      breadcrumb: [
        { name: "message.aside.home", link: "/" },
        { name: "message.aside.krefeldplan" },
      ],
    },
  },
  {
    path: "/krefelddocuments",
    name: "KrefeldDocuments",
    component: KrefeldDocumentsPage,
    meta: {
      requiredAuth: false,
      module: "mymint",
      breadcrumb: [
        { name: "message.aside.home", link: "/" },
        { name: "message.aside.krefeldplan" },
        { name: "Krefeld documents" },
      ],
    },
  },
  {
    path: "/edl",
    name: "EdlPage",
    component: EdlPage,
    meta: {
      requiredAuth: true,
      module: "mydoc",
      breadcrumb: [
        { name: "message.aside.home", link: "/" },
        { name: "message.aside.edl" },
      ],
    },
  },

  {
    path: "/infoloc",
    name: "InfoLocoPage",
    component: InfoLocoPage,
    meta: {
      requiredAuth: true,
      module: "mymint",
      breadcrumb: [
        { name: "message.aside.home", link: "/" },
        { name: "message.aside.magic", link: "/mymint" },
        { name: "message.aside.infoloc" },
      ],
    },
  },

  {
    path: "/infoloc/:asset",
    name: "InfoLocPage",
    props: true,
    component: InfoLocoPage,
    meta: {
      requiredAuth: true,
      module: "mymint",
      breadcrumb: [
        { name: "message.aside.home", link: "/" },
        { name: "message.aside.magic", link: "/mymint" },
        { name: "message.aside.infoloc" },
      ],
    },
  },
  {
    path: "/infoloc/:loco/wheelset",
    name: "WheelsetPage",
    component: WheelsetPage,
    meta: {
      requiredAuth: true,
      module: "mymint",
      breadcrumb: [
        { name: "message.aside.home", link: "/" },
        { name: "message.aside.magic", link: "/mymint" },
        { name: "message.aside.infoloc" },
        { name: "message.infoloc.wheelset" },
      ],
    },
  },
  {
    path: "/mymint",
    name: "MagicPage",
    component: MagicPage,
    meta: {
      requiredAuth: true,
      module: "mymint",
      breadcrumb: [
        { name: "message.aside.home", link: "/" },
        { name: "message.aside.magic" },
      ],
    },
  },
  {
    path: "/alert",
    name: "AlertPage",
    component: AlertPage,
    meta: {
      requiredAuth: true,
      module: "myfleet",
      breadcrumb: [
        { name: "message.aside.home", link: "/" },
        { name: "message.aside.account" },
        { name: "message.aside.alert" },
      ],
    },
    children: [
      {
        path: "battery",
        component: PortalAlertTable,
        name: "AlertBatteryPage",
        meta: {
          requiredAuth: true,
          module: "myfleet",
        },
      },
      {
        path: "poi",
        component: PortalAlertTable,
        meta: {
          requiredAuth: true,
          module: "alert",
        },
      },
      {
        path: "sr",
        component: AlertSrTable,
        name: "AlertSrPage",
        meta: {
          requiredAuth: true,
          module: "myfleet",
        },
      },
      {
        path: "quotation",
        component: AlertQuotation,
        name: "AlertQuotationPage",
        meta: {
          requiredAuth: true,
          module: "myfleet",
        },
      },
    ],
  },
  {
    path: "/poi",
    name: "PoiPage",
    component: PoiPage,
    meta: {
      requiredAuth: true,
      module: "myfleet",
      breadcrumb: [
        { name: "message.aside.home", link: "/" },
        { name: "message.aside.planning" },
        { name: "message.maintenance.workshops" },
      ],
    },
  },
  {
    path: "/geoloc",
    name: "GeolocPage",
    component: GeolocPage,
    meta: {
      requiredAuth: true,
      module: "myfleet",
      breadcrumb: [
        { name: "message.aside.home", link: "/" },
        { name: "message.aside.parc" },
        { name: "message.aside.geo" },
      ],
    },
  },
  {
    path: "/km",
    name: "KmPage",
    component: KmPage,
    meta: {
      requiredAuth: true,
      module: "myfleet",
      breadcrumb: [
        { name: "message.aside.home", link: "/" },
        { name: "message.aside.parc" },
        { name: "message.aside.km" },
      ],
    },
  },
  {
    path: "/disponibility",
    name: "DisponibilityPage2",
    component:DisponibilityContractuellePage ,
    meta: {
      requiredAuth: true,
      module: "myfleet",
      breadcrumb: [
        { name: "message.aside.home", link: "/" },
        { name: "message.aside.parc" },
        { name: "message.aside.disponibility" },
      ],
    },
  },
  {
    path: "/hm",
    name: "HmPage",
    component: HmPage,
    meta: {
      requiredAuth: true,
      module: "myfleet",
      breadcrumb: [
        { name: "message.aside.home", link: "/" },
        { name: "message.aside.parc" },
        { name: "message.aside.hm" },
      ],
    },
  },
  {
    path: "/flotte",
    name: "DispoPage",
    component: DispoPage,
    meta: {
      requiredAuth: true,
      module: "myfleet",
      breadcrumb: [
        { name: "message.aside.home", link: "/" },
        { name: "message.aside.parc" },
        { name: "message.aside.detail" },
      ],
    },
  },
  {
    path: "/monitoring",
    name: "MonitoringPage",
    component: MonitoringPage,
    meta: {
      requiredAuth: true,
      module: "myfleet",
      breadcrumb: [
        { name: "message.aside.home", link: "/" },
        { name: "message.aside.parc" },
        { name: "Monitoring technique" },
      ],
    },
  },
  {
    path: "/infoBattery",
    name: "InfoBatteryPage",
    component: InfoBatteryPage,
    meta: {
      requiredAuth: true,
      module: "myfleet",
      breadcrumb: [
        { name: "message.aside.home", link: "/" },
        { name: "message.aside.parc" },
        { name: "Monitoring battery" },
      ],
    },
  },
  {
    path: "/geofencing",
    name: "GeofencingPage",
    component: GeofencingPage,
    meta: {
      requiredAuth: true,
      module: "myfleet",
      breadcrumb: [
        { name: "message.aside.home", link: "/" },
        { name: "message.aside.parc" },
        { name: "message.aside.geofencing" },
      ],
    },
  },
  {
    path: "/password/:token",
    name: "PasswordPage",
    component: PasswordPage,
    meta: {
      requiredAuth: false,
    },
  },
  {
    path: "/resetPassword/:token",
    name: "PasswordResetPage",
    component: PasswordResetPage,
    meta: {
      requiredAuth: false,
    },
  },
  {
    path: "/maintenance",
    name: "MaintenancePage",
    component: MaintenancePage,
    meta: {
      analyticsIgnore: true,
    },
  },
  {
    path: "/quotes",
    name: "QuotePage",
    component: QuotePage,
    meta: {
      requiredAuth: true,
      module: "mydoc",
      breadcrumb: [
        { name: "message.aside.home", link: "/" },
        { name: "message.extrawork.title" },
      ],
    },
  },
  {
    path: "/intern/loco",
    name: "InternLocoPage",
    component: InternLocoPage,
    meta: {
      requiredAuth: true,
      breadcrumb: [
        { name: 'message.aside.home', link: '/' },
        { name: 'message.aside.infoloc' }
      ]
    }
  },
  {
    path: "*",
    name: "NotFoundPage",
    component: NotFoundPage,
    meta: {
      analyticsIgnore: true,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach(async (to, from, next) => {
  let tok = to.query.token;

  if (["PasswordPage", "KrefeldDocuments", "PasswordResetPage"].includes(to.name)) {
    return next();
  }

  if (tok) {
    const data = {
      token: tok,
    };
    localStorage.setItem("access_token", tok);
    store.commit("auth/saveTokenData", data);
    store.commit("auth/setdateConn", new Date());
    store.commit("auth/setLoginStatus", "success");
    return next({ path: "/" });
  }

  if (!store.getters["auth/getAuthData"].token) {
    const access_token = localStorage.getItem("access_token");
    if (access_token) {
      const data = {
        token: access_token,
      };
      store.commit("auth/saveTokenData", data);
      store.commit("auth/setLoginStatus", "success");
    }
  }

  let auth = store.getters["auth/isTokenActive"];
  let functionalities = store.getters["auth/getFunctionnalities"];
  let internal = store.getters["auth/isAdUser"];

  if (!auth && to.meta.requiredAuth) {
    return next({ path: "/login" });
  }

  if (to.path.startsWith("/config") && !functionalities.includes("it")) {
    return next({ path: "/"});
  }
  
  if (to.path.startsWith("/intern") && !internal) {
    return next({ path: "/"});
  }

  if (functionalities.includes("all")) {
    return next();
  }

  if (functionalities.includes("myfleet")) {
    return next();
  }

  if (functionalities.includes(to.meta.module)) {
    return next();
  }

  if ([
      "TeamPage",
      "NoticePage",
      "MagicPage",
      "LoginPage",
      "KrefeldPlan"
    ].includes(to.name)) {
    return next();
  }

  return next({ path: "/mymint" });
});

export default router;
